import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faCreditCard, faEdit, faPaperPlane, faTrash } from "@fortawesome/free-solid-svg-icons";
import { ExpenseApi, ExpenseDataType } from "@/api/ExpenseApi";
import { formatMoneyValue } from "@utils/Currency";
import { showAlert } from "@utils/Alert";
import styles from "./style.module.scss";
import moment from "moment";

const ExpenseIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ExpenseApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Gasto no puedo ser eliminado');
    } else {
      showAlert('success', 'El Gasto fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista de Gastos"
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/expenses/add')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ExpenseDataType>
        ref={modelRef}
        meiliConfig={{
          index: "expenses",
          sort: ["createdAt:desc"]
        }}
        fetchData={(...args) => ExpenseApi.fetchAll(...args)}
        filterProps={[
          {
            key: "sequence",
            filterType: "contains"
          },
          {
            key: "document_key",
            filterType: "contains"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: "nombre",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.fecha, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: "sequence",
            title: "Numero Consecutivo"
          },
          {
            key: (data) => {
              if ("currency_id" in data) {
                return formatMoneyValue(data.monto, (data as any).currency_id)
              }
              return formatMoneyValue(data.monto, data.currency.currency_id)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "4" },
            { sm: "4", md: "2" }
          ]
        }
        listActions={[
          {
            isVisible: (data) => !!data.atvMessages && data.atvMessages?.length > 0,
            href: "/user/atv-messages/listByExpense/{:id}",
            actionTitle: "Ver Mensajes de ATV",
            iconProps: { icon: faPaperPlane }
          },
          {
            href: "/user/expenses/edit/{:id}",
            actionTitle: "Editar Gastos",
            iconProps: { icon: faEdit }
          },
          {
            href: "/user/expenses/notes/{:id}",
            actionTitle: "Notas de Credito",
            iconProps: { icon: faCreditCard }
          },
          {
            actionTitle: "Eliminar Gastos",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Gasto",
              confirmMessage: "¿Seguro que desea eliminar este gasto?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ExpenseIndex;
